import { withStyles } from '@material-ui/core';
import InsightCard from './InsightCard';
import styles from './styles';

export default withStyles(styles)(InsightCard);
